define('util/transitionEnd',[], function(){

	var element = document.createElement('div');
	var transitions = {
			'MozTransition': 'transitionend',
			'WebkitTransition': 'webkitTransitionEnd',
			'transition': 'transitionEnd',
			'MSTransition': 'msTransitionEnd',
			'OTransition': 'oTransitionEnd'
	};

	return function(){

		for(var t in transitions){
			if(element.style[t] !== undefined){
				return transitions[t];
			}
		}
	};
});

